import { Button } from '@/components/ui/button';
import { trackEvent } from '@/lib/analytics';

interface StickyMobileCTAProps {
  onClick: () => void;
}

export const StickyMobileCTA = ({ onClick }: StickyMobileCTAProps) => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <Button
          size="lg"
          className="w-full"
          onClick={() => {
            trackEvent('cta_click', { location: 'sticky_mobile', action: 'register' });
            onClick();
          }}
        >
          Register Interest
        </Button>
      </div>
    </div>
  );
};
